import SupportLink from './support-link';

export default SupportLink;
